import { useLocation } from 'react-router';
import { cloneElement, useEffect, useMemo, useRef } from 'react';

export const getHash = (location) => {
    if (!location.hash) return null;
    return location.hash.slice(1);
};

export const ScrollToHashElement = ({ children }) => {
    const ref = useRef(null);
    let location = useLocation();
    let hashElement = useMemo(() => {
        const hash = getHash(location);
        if (hash && ref?.current?.id === hash) {
            return ref.current;
        } else {
            return null;
        }
    }, [location, ref?.current]);

    useEffect(() => {
        if (hashElement) {
            hashElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    }, [hashElement]);

    return cloneElement(children, { ...children.props, ref });
};
